import getUserLocale from "get-user-locale"
import { DEFAULT_LANG_LIST } from "../constants"

const DEFAULT_LANG = "en"
export const autoDetectBrowserLang = () => {
  const userLocale = getUserLocale()

  if (!userLocale) {
    return DEFAULT_LANG
  }

  const lang = userLocale.split("-")[0]

  if (!lang) {
    return DEFAULT_LANG
  }

  const langItem = DEFAULT_LANG_LIST.find(item => item.lang === lang)

  if (!langItem) {
    return DEFAULT_LANG
  }

  return langItem.lang
}
